import { useState } from 'react';
import enviro from 'enviro';
import I18n from 'I18n';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { AIReconnectModal } from './AIReconnectModal';
import { getAppNameByAppId } from '../../../../constants/AppIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AIReconnectButton = ({
  buttonComponent: ButtonComponent,
  buttonProps,
  loading,
  label,
  metadata,
  onAuthSucceeded,
  onAuthCancelled
}) => {
  const [open, setOpen] = useState(false);
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const appName = getAppNameByAppId(appId || 0);
  if (!appId) {
    if (enviro.isQa()) {
      console.warn('AIReconnectButton: Missing required props or reconnect config', {
        appId,
        appName
      });
    }
    return null;
  }
  const isLoading = loading || open;
  const handleClick = evt => {
    var _buttonProps$onClick;
    buttonProps === null || buttonProps === void 0 || (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps, evt);
    setOpen(true);
  };
  const handleCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      error: new Error('Reconnection was not completed'),
      errorMessage: I18n.text('reconnectionError.commonMessage'),
      queryParams: new URLSearchParams(window.location.search).toString()
    });
    setOpen(false);
  };
  const handleComplete = () => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded('connected');
    setOpen(false);
  };
  const handleError = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      error: new Error('Reconnection failed'),
      errorMessage: I18n.text('reconnectionError.commonMessage'),
      queryParams: new URLSearchParams(window.location.search).toString()
    });
    setOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ButtonComponent ? /*#__PURE__*/_jsx(ButtonComponent, Object.assign({}, buttonProps, {
      onClick: handleClick,
      children: label
    })) : /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, buttonProps, {
      loading: isLoading,
      onClick: handleClick,
      children: label
    })), open && /*#__PURE__*/_jsx(AIReconnectModal, {
      appId: appId,
      onClose: handleCancel,
      onSuccess: handleComplete,
      onFailure: handleError
    })]
  });
};